<template>
  <DefaultModal @close="$emit('close')">
    <template #header>
      <DefaultModalTitle>Neka ansökan på grund av</DefaultModalTitle>
    </template>

    <template #body>
      <transition name="textarea-toggle" appear>
        <div class="textarea-wrapper">
          <textarea
            :value="note"
            class="area"
            :disabled="isSaving"
            cols="30"
            rows="5"
            @input="note = $event.target.value"
          ></textarea>
          <!-- <p style="position: absolute">
            OBS! Endast anslutna hyresvärdar får ta del av denna information.
          </p> -->
        </div>
      </transition>
    </template>

    <template #footer>
      <BaseButton
        :is-loading="isSaving"
        :is-rounded="true"
        :is-warning="true"
        :is-disabled="note.length === 0"
        :icon="svgs.ICONS.ERROR_WHITE"
        @click="rejectOvApplication"
      >
        Neka ansökan
      </BaseButton>
      <BaseButton
        :is-disabled="isSaving"
        :is-rounded="true"
        :is-default="true"
        @click="$emit('close')"
        >Avbryt</BaseButton
      >
    </template>
  </DefaultModal>
</template>

<script>
import DefaultModal from '@/components/DefaultModal.vue';
import BaseButton from '@/components/BaseButton.vue';
import DefaultModalTitle from '@/components/DefaultModalTitle.vue';
import svgs from '@/utils/icon-constants';
import { mapActions } from 'vuex';
// import churnService from '@/utils/churn360';
// import { events, features } from '@/utils/trackingEvents';

export default {
  name: 'OvRejectModal',
  components: {
    DefaultModal,
    BaseButton,
    DefaultModalTitle
  },

  props: {
    applicationId: {
      type: Number,
      default: null
    }
  },
  emits: ['close', 'onRejected'],

  data() {
    return {
      svgs,
      isSaving: false,
      note: ''
    };
  },

  methods: {
    ...mapActions({
      rejectOvApp: 'applications/rejectOvApp'
    }),
    async rejectOvApplication() {
      this.isSaving = true;
      await this.rejectOvApp({ id: this.applicationId, note: this.note });
      // churnService.track(
      //   events.CHANGE_SWAP_STATUS,
      //   features.CHANGE_SWAP_STATUS.REJECT
      // );
      this.isSaving = false;
      this.$emit('onRejected');
    }
  }
};
</script>

<style scoped></style>
